module.exports = {
  webRoutes: [
    {
      path: '/platformPortal',
      name: 'platformPortal',
      component: () => import('@/views/MPlatformPortal'),
      meta: {
        title: '平台门户'
      }
    },
    {
      path: '/searchMore',
      name: 'searchMore',
      component: () => import('@/views/backstageSupport/pages/searchMore'),
      meta: {
        title: '平台门户'
      }
    },

    {
      path: '/intelligenceMatch',
      name: 'intelligenceMatch',
      component: () => import('@/views/IntelligenceMatch'),
      meta: {
        title: '智能撮合'
      }
    },
    // {
    //   path: '/tradingMarket',
    //   name: 'tradingMarket',
    //   component: () => import('@/views/MTradingMarket'),
    //   meta: {
    //     title: '成果展示,成果展示',
    //   },
    // },
    {
      path: '/openLicense',
      name: 'openLicense',
      component: () => import('@/views/OpenLicense'),
      meta: {
        title: '开放许可,开放许可'
      }
    },
    {
      path: '/openLicense/licenseDetailDeal',
      name: 'licenseDetailDeal',
      component: () => import('@/views/OpenLicense/pages/DetailDeal'),
      meta: {
        title: '开放许可,交易详情'
      }
    },
    {
      path: '/achievementDisplay',
      name: 'achievementDisplay',
      component: () => import('@/views/AchievementDisplay'),
      meta: {
        title: '成果展示,成果展示'
      }
    },
    {
      path: '/achievementDisplay/tradingMarketInfos',
      name: 'dealInfos',
      component: () => import('@/views/MTradingMarket/pages/DealInfos'),
      meta: {
        title: '成果展示,成果列表'
      }
    },
    {
      path: '/tradingMarket/announcement',
      name: 'announcement',
      component: () => import('@/views/MTradingMarket/pages/Announcement'),
      meta: {
        title: '成果展示,交易公告'
      }
    },
    {
      path: '/tradingMarket/announcement/detailAnnounce',
      name: 'detailAnnouncement',
      component: () => import('@/views/MTradingMarket/pages/DetailAnnounce'),
      meta: {
        title: '成果展示,交易公告详情'
      }
    },
    {
      path: '/achievementDisplay/tradingMarketInfos/detailDeal',
      name: 'detailDeal',
      component: () => import('@/views/MTradingMarket/pages/DetailDeal'),
      meta: {
        title: '成果展示,交易详情'
      }
    },
    {
      path: '/achievementDisplay/demandMark',
      name: 'demandMark',
      component: () => import('@/views/MTradingMarket/pages/DemandMark'),
      meta: {
        title: '成果展示,需求市场'
      }
    },
    {
      path: '/tradingMarket/demandMark/detailDemand',
      name: 'detailDemand',
      component: () => import('@/views/MTradingMarket/pages/DetailDemand'),
      meta: {
        title: '成果展示,需求详情'
      }
    },
    {
      path: '/industryData',
      name: 'industryData',
      component: () => import('@/views/MIndustryData'),
      meta: {
        title: '产业数据库'
      }
    },
    {
      path: '/competitorData',
      name: 'competitorData',
      component: () => import('@/views/MCompetitorData'),
      meta: {
        title: '竞争对手情报库'
      }
    },
    {
      path: '/competitorData/detail',
      name: 'competitorDetail',
      component: () => import('@/views/MCompetitorData/pages/detail'),
      meta: {
        title: '竞争对手情报库,详情'
      }
    },
    {
      path: '/serviceAndSupport',
      name: 'serviceAndSupport',
      component: () => import('@/views/MServiceAndSupport'),
      meta: {
        title: '服务机构,服务机构'
      }
    },
    {
      path: '/serviceAndSupport/detail',
      name: 'serviceSupportDetail',
      component: () =>
        import('@/views/MServiceAndSupport/pages/ServiceSupportDetail'),
      meta: {
        title: '服务机构,服务与支持'
      }
    },
    {
      path: '/ipFinancialProducts',
      name: 'ipFinancialProducts',
      component: () => import('@/views/MServiceIpFinancialProducts'),
      meta: {
        title: '服务与支持,IP金融产品'
      }
    },
    {
      path: '/ipFinancialProducts/detail',
      name: 'ipFinancialProducts',
      component: () =>
        import('@/views/MServiceIpFinancialProducts/pages/IpProject'),
      meta: {
        title: 'IP金融产品详情'
      }
    },
    {
      path: '/thirdServices',
      name: 'thirdServices',
      component: () => import('@/views/MServiceThirdServices'),
      meta: {
        title: '服务与支持,第三方服务'
      }
    },
    {
      path: '/generalInfo',
      name: 'generalInfo',
      component: () => import('@/views/MGeneralInfo'),
      meta: {
        title: '新闻资讯'
      }
    },
    {
      path: '/generalInfo',
      name: 'generalInfo',
      component: () => import('@/views/MGeneralInfo'),
      meta: {
        title: '综合信息,行业资讯'
      }
    },
    {
      path: '/generalInfo',
      name: 'generalInfo',
      component: () => import('@/views/MGeneralInfo'),
      meta: {
        title: '综合信息,政策制度'
      }
    },
    {
      path: '/generalInfo',
      name: 'generalInfo',
      component: () => import('@/views/MGeneralInfo'),
      meta: {
        title: '综合信息,产业分析'
      }
    },
    {
      path: '/generalInfo/details',
      name: 'generalInfoDetails',
      component: () => import('@/views/MGeneralInfo/pages/details.vue'),
      meta: {
        title: '新闻资讯,详情信息'
      }
    },
    {
      path: '/TechnicalRLibrary',
      name: 'TechnicalRLibrary',
      component: () => import('@/views/TechnicalRLibrary'),
      meta: {
        title: '技术需求库,技术需求库'
      }
    },
    {
      path: '/TechnicalRLibrary/techDealInfos',
      name: 'techDealInfos',
      component: () => import('@/views/TechnicalRLibrary/techDealInfos'),
      meta: {
        title: '技术需求库,技术需求库列表'
      }
    },
    {
      path: '/TechnicalRLibrary/techDealInfos/techDetailDeal',
      name: 'techDetailDeal',
      component: () => import('@/views/TechnicalRLibrary/techDetailDeal'),
      meta: {
        title: '技术需求库,技术需求库详情'
      }
    },
    {
      path: '/talentData',
      name: 'talentData',
      component: () => import('@/views/MTalentData'),
      meta: {
        title: '人才团队,人才团队'
      }
    },

    {
      path: '/talentData/talentList',
      name: 'talentList',
      component: () => import('@/views/MTalentData/pages/talentList'),
      meta: {
        title: '人才团队,人才团队列表'
      }
    },
    {
      path: '/talentData/talentList/detail',
      name: 'talentDetail',
      component: () => import('@/views/MTalentData/pages/TalentDetail/index'),
      meta: {
        title: '人才团队,人才详情页'
      }
    },
    {
      path: '/talentData/TechnicalTeam',
      name: 'TechnicalTeam',
      component: () => import('@/views/MTalentData/pages/TechnicalTeam'),
      meta: {
        title: '人才团队,技术团队列表'
      }
    },
    {
      path: '/talentData/TechnicalTeam/TechnicalTeamDetail',
      name: 'TechnicalTeamDetail',
      component: () => import('@/views/MTalentData/pages/TechnicalTeamDetail'),
      meta: {
        title: '人才团队,技术团队详情'
      }
    },
    {
      path: '/IndustryInformation',
      name: 'IndustryInformation',
      component: () => import('@/views/IndustryInformation'),
      meta: {
        title: '产业信息服务,产业信息服务'
      }
    },
    {
      path: '/IndustryInformation/List',
      name: 'IndustryInformationList',
      component: () =>
        import('@/views/IndustryInformation/pages/IndustryInformationList'),
      meta: {
        title: '产业信息服务,产业信息列表'
      }
    },
    {
      path: '/IndustryInformation/Detail',
      name: 'IndustryInformationDetail',
      component: () =>
        import('@/views/IndustryInformation/pages/IndustryInformationDetail'),
      meta: {
        title: '产业信息服务,产业信息列表详情页'
      }
    },
    {
      path: '/IndustryInformation/IndustryNavigationList',
      name: 'IndustryNavigationList',
      component: () =>
        import('@/views/IndustryInformation/pages/IndustryNavigationList'),
      meta: {
        title: '产业信息服务,产业导航列表'
      }
    },
    {
      path: '/IndustryInformation/IndustryNavigationDetail',
      name: 'IndustryNavigationDetail',
      component: () =>
        import('@/views/IndustryInformation/pages/IndustryNavigationDetail'),
      meta: {
        title: '产业信息服务,产业导航列表详情'
      }
    }
  ]
}
